(function () {
  if (window.TieredCartDiscount) {
    window.TieredCartDiscount.init();
    return;
  }

  function normalizeDiscountName(name) {
    return String(name || "")
      .trim()
      .toUpperCase();
  }

  function parseConfig(root) {
    var configEl = root.querySelector("[data-tiered-cart-discount-config]");
    if (!configEl) return [];

    function normalizeGiftProduct(gp) {
      if (!gp) return null;
      if (typeof gp !== "object") return null;
      var giftText = String(gp.giftText || "").trim();
      var giftImageUrl = String(gp.giftImageUrl || "").trim();
      if (!giftText && !giftImageUrl) return null;
      return {
        giftText: giftText,
        giftImageUrl: giftImageUrl,
      };
    }

    try {
      var config = JSON.parse(configEl.textContent);
      return (config.tiers || [])
        .filter(function (tier) {
          if (!tier) return false;
          if (!(Number(tier.threshold) > 0)) return false;
          // Must have at least one "human visible" identifier, otherwise this
          // is an empty/placeholder tier that should be skipped. Free-gift
          // tiers do NOT rely on discountName (it's intentionally cleared
          // when the merchant selects reward_type=free_gift), so we accept
          // label/giftProduct as valid identifiers too.
          var hasDiscountName = Boolean(String(tier.discountName || "").trim());
          var hasLabel = Boolean(String(tier.label || "").trim());
          var gp = tier.giftProduct && typeof tier.giftProduct === "object" ? tier.giftProduct : null;
          var hasGiftProduct = Boolean(
            gp && (
              String(gp.giftText || "").trim() ||
              String(gp.giftImageUrl || "").trim()
            ),
          );
          return hasDiscountName || hasLabel || hasGiftProduct;
        })
        .map(function (tier) {
          var rewardType = tier.rewardType === "free_gift" ? "free_gift" : "amount_discount";
          return {
            threshold: Number(tier.threshold),
            discountAmount: Number(tier.discountAmount || 0),
            discountName: String(tier.discountName || "").trim(),
            label: stripHtml(
              String(tier.label || tier.discountName || "").trim(),
            ),
            milestoneLabel: stripHtml(
              String(tier.milestoneLabel || tier.label || "").trim(),
            ),
            rewardType: rewardType,
            giftProduct: rewardType === "free_gift" ? normalizeGiftProduct(tier.giftProduct) : null,
          };
        })
        .sort(function (a, b) {
          return a.threshold - b.threshold;
        })
        .slice(0, 3);
    } catch (error) {
      return [];
    }
  }

  function formatMoney(cents, format, currencyCode) {
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      return window.Shopify.formatMoney(
        cents,
        format || window.theme?.moneyFormat || "${{amount}}",
      );
    }

    var amount = (Number(cents || 0) / 100).toFixed(2);
    var symbols = {
      USD: "$",
      GBP: "£",
      EUR: "€",
      CAD: "CA$",
      AUD: "A$",
      JPY: "¥",
    };
    var symbol = symbols[String(currencyCode || "USD").toUpperCase()] || "";
    return symbol + amount;
  }

  function stripHtml(value) {
    return String(value || "").replace(/<[^>]*>/g, "");
  }

  function truncateLong(value, max) {
    var s = String(value == null ? "" : value);
    var m = typeof max === "number" && max > 0 ? max : 40;
    return s.length > m ? s.slice(0, m) + "…" : s;
  }

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function replaceTokensPlain(template, data) {
    var progressValue = String(data.progress != null ? data.progress : "");

    return String(template || "")
      .replace(/\[\[amount\]\]/g, data.amount || "")
      .replace(/\[\[discount\]\]/g, truncateLong(data.discount || "", 40))
      .replace(/\[\[label\]\]/g, truncateLong(data.label || "", 50))
      .replace(/\[\[name\]\]/g, truncateLong(data.name || "", 40))
      .replace(/\[\[progress\]\]/g, progressValue);
  }

  function replaceTokens(template, data) {
    var amountHtml =
      '<strong class="tiered-cart-discount__message-amount">' +
      escapeHtml(data.amount || "") +
      "</strong>";
    var discountHtml =
      '<strong class="tiered-cart-discount__message-label">' +
      escapeHtml(truncateLong(data.discount || "", 40)) +
      "</strong>";
    var labelHtml =
      '<strong class="tiered-cart-discount__message-label">' +
      escapeHtml(truncateLong(data.label || "", 50)) +
      "</strong>";
    var nameHtml = "<strong>" + escapeHtml(truncateLong(data.name || "", 40)) + "</strong>";
    var progressValue = String(data.progress != null ? data.progress : "");

    return String(template || "")
      .replace(/\[\[amount\]\]/g, amountHtml)
      .replace(/\[\[discount\]\]/g, discountHtml)
      .replace(/\[\[label\]\]/g, labelHtml)
      .replace(/\[\[name\]\]/g, nameHtml)
      .replace(/\[\[progress\]\]/g, escapeHtml(progressValue));
  }

  function getAppliedDiscountTitles(cart) {
    var titles = [];
    var applications = []
      .concat(cart.cart_level_discount_applications || [])
      .concat(cart.discount_applications || []);

    applications.forEach(function (discount) {
      if (discount && discount.title) titles.push(String(discount.title));
    });

    return titles.map(normalizeDiscountName).filter(Boolean);
  }

  function getMatchedTierIndex(tiers, totalPrice) {
    var matchedIndex = -1;
    tiers.forEach(function (tier, index) {
      if (totalPrice >= tier.threshold) matchedIndex = index;
    });
    return matchedIndex;
  }

  function getProgressSegment(tiers, totalPrice) {
    var matchedIndex = getMatchedTierIndex(tiers, totalPrice);
    var maxTier = tiers[tiers.length - 1] || { threshold: 0, label: "" };
    var totalProgress =
      maxTier.threshold > 0 ? totalPrice / maxTier.threshold : 0;

    if (matchedIndex >= tiers.length - 1) {
      var previousTier =
        tiers.length > 1
          ? tiers[tiers.length - 2]
          : { threshold: 0, label: "" };
      return {
        startTier: previousTier,
        endTier: tiers[tiers.length - 1],
        progress: 1,
        allUnlocked: true,
        matchedTier: tiers[tiers.length - 1],
      };
    }

    var nextIndex = matchedIndex + 1;
    var startTier =
      matchedIndex >= 0 ? tiers[matchedIndex] : { threshold: 0, label: "" };
    var endTier = tiers[nextIndex];
    var range = endTier.threshold - startTier.threshold;
    var segmentProgress =
      range > 0 ? (totalPrice - startTier.threshold) / range : 0;

    return {
      startTier: startTier,
      endTier: endTier,
      progress: Math.min(1, Math.max(0, totalProgress)),
      segmentProgress: Math.min(1, Math.max(0, segmentProgress)),
      allUnlocked: false,
      matchedTier: matchedIndex >= 0 ? tiers[matchedIndex] : null,
      nextTier: endTier,
    };
  }

  function isDesignMode(root) {
    if (root && root.dataset.designMode === "true") return true;
    return Boolean(window.Shopify && window.Shopify.designMode);
  }

  function getPreviewTotalPrice(tiers, root) {
    if (root && root.dataset.previewTotal) {
      return Number(root.dataset.previewTotal) || 0;
    }

    if (!tiers.length) return 0;

    var startTier = { threshold: 0 };
    var endTier = tiers.length > 1 ? tiers[1] : tiers[0];
    var range = endTier.threshold - startTier.threshold;

    if (range <= 0) {
      return Math.round(endTier.threshold * 0.72);
    }

    return Math.round(startTier.threshold + range * 0.72);
  }

  function getCartSubtotal(cart) {
    return (
      Number(cart && cart.original_total_price) ||
      Number(cart && cart.items_subtotal_price) ||
      Number(cart && cart.total_price) ||
      0
    );
  }

  function resolveCartForRoot(cart, tiers, root) {
    if (!isDesignMode(root)) return cart;

    var itemCount = Number(cart && cart.item_count) || 0;
    if (itemCount > 0) return cart;

    var previewTotal = getPreviewTotalPrice(tiers, root);
    return Object.assign({}, cart || {}, {
      original_total_price: previewTotal,
      items_subtotal_price: previewTotal,
      total_price: previewTotal,
      item_count: 1,
    });
  }

  function fetchCart() {
    return fetch("/cart.js", {
      credentials: "same-origin",
      headers: {
        accept: "application/json",
      },
    }).then(function (response) {
      if (!response.ok) throw new Error("Unable to read cart");
      return response.json();
    });
  }

  function prefersReducedMotion() {
    return (
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches
    );
  }

  function triggerEnterAnimation(root) {
    if (!root || prefersReducedMotion() || root.dataset.tcdEntered === "true")
      return;

    root.dataset.tcdEntered = "true";
    root.classList.add("is-entering");
    window.setTimeout(function () {
      root.classList.remove("is-entering");
    }, 700);
  }

  function triggerCelebrate(root, reason) {
    if (!root || prefersReducedMotion() || !reason) return;

    root.classList.remove("is-celebrate");
    void root.offsetWidth;
    root.classList.add("is-celebrate");
    window.clearTimeout(root._tcdCelebrateTimer);
    root._tcdCelebrateTimer = window.setTimeout(function () {
      root.classList.remove("is-celebrate");
    }, 700);
  }

  function triggerProgressAnimation(trackEl, fillPercent) {
    if (!trackEl || prefersReducedMotion()) return;

    var previousFill = Number(trackEl.dataset.tcdFill || 0);
    if (fillPercent <= previousFill) return;

    trackEl.dataset.tcdFill = String(fillPercent);
    trackEl.classList.remove("is-advancing");
    void trackEl.offsetWidth;
    trackEl.classList.add("is-advancing");
    window.clearTimeout(trackEl._tcdAdvanceTimer);
    trackEl._tcdAdvanceTimer = window.setTimeout(function () {
      trackEl.classList.remove("is-advancing");
    }, 650);
  }

  function bindInitialIconFallback(root) {
    if (!root || root.dataset.tcdIconBound === "true") return;

    var startNodeEl = root.querySelector("[data-tcd-start-node]");
    var imageEl = root.querySelector("[data-tcd-initial-image]");
    if (!startNodeEl || !imageEl) return;

    root.dataset.tcdIconBound = "true";

    function useSvgFallback() {
      startNodeEl.classList.remove("has-custom-icon");
      imageEl.remove();
    }

    if (imageEl.complete && imageEl.naturalWidth === 0) {
      useSvgFallback();
      return;
    }

    imageEl.addEventListener("error", useSvgFallback);
  }

  function setLoading(root, isLoading) {
    if (!root) return;
    root.classList.toggle("is-loading", isLoading);
  }

  function setEndNodeState(nodeEl, isUnlocked) {
    if (!nodeEl) return;

    nodeEl.classList.toggle("is-unlocked", isUnlocked);
    nodeEl.classList.toggle("tiered-cart-discount__node--target", !isUnlocked);
  }

  function truncateGiftName(tier, maxLen) {
    var m = typeof maxLen === "number" && maxLen > 0 ? maxLen : 32;
    if (tier && tier.giftProduct && tier.giftProduct.giftText) {
      return truncateLong(tier.giftProduct.giftText, m);
    }
    return "";
  }

  function renderNodeGift(nodeEl, tier) {
    if (!nodeEl) return;
    // 清理之前注入的礼品图
    var prevImg = nodeEl.querySelector("img.tiered-cart-discount__node-gift-image");
    if (prevImg) prevImg.remove();
    nodeEl.classList.remove("has-gift-image");

    if (!tier || !tier.giftProduct || !tier.giftProduct.giftImageUrl) return;

    // 目标节点（未解锁）：礼品图替代价格标签图标
    var isTarget = nodeEl.classList.contains("tiered-cart-discount__node--target") &&
      !nodeEl.classList.contains("is-unlocked");
    // 起点已通过节点（free_gift 档解锁后）：礼品图替代对勾/卡车图标
    var isStartPassed = !isTarget &&
      nodeEl.classList.contains("is-tier-passed") &&
      !nodeEl.classList.contains("tiered-cart-discount__node--target");

    if (!isTarget && !isStartPassed) return;

    // 目标节点有 .node-inner 包裹；起点节点直接在 .node 下注入
    var container = isTarget
      ? nodeEl.querySelector(".tiered-cart-discount__node-inner")
      : nodeEl;
    if (!container) return;

    nodeEl.classList.add("has-gift-image");
    var img = document.createElement("img");
    img.className = "tiered-cart-discount__node-gift-image";
    img.src = tier.giftProduct.giftImageUrl;
    var altText = truncateGiftName(tier, 32) || tier.giftProduct.giftText || "Gift";
    img.alt = escapeHtml(altText);
    container.appendChild(img);
  }

  function renderMilestoneGift(amountEl, tier) {
    if (!amountEl || !tier) return;
    // --- Clear any previously rendered gift-block + old legacy nodes ---
    var prevGiftBlock = amountEl.querySelector(".tiered-cart-discount__milestone-gift-block");
    if (prevGiftBlock) prevGiftBlock.remove();
    var prevThumbLink = amountEl.querySelector(".tiered-cart-discount__gift-thumb-link");
    if (prevThumbLink) prevThumbLink.remove();
    var prevNameLink = amountEl.querySelector(".tiered-cart-discount__milestone-gift-name-link");
    if (prevNameLink) prevNameLink.remove();
    var prevThumb = amountEl.querySelector(".tiered-cart-discount__gift-thumb");
    if (prevThumb) prevThumb.remove();
    var prevName = amountEl.querySelector(".tiered-cart-discount__gift-name");
    if (prevName) prevName.remove();
    var milestone = amountEl.parentElement;
    if (milestone) {
      milestone.classList.remove("has-gift");
      milestone.classList.remove("has-node-gift");
    }

    var gp = tier && tier.giftProduct;
    var shortName = truncateGiftName(tier, 32);
    var hasGiftContent = Boolean(gp && (gp.giftImageUrl || shortName));

    // --- 找到对应的节点圆圈 ---
    var nodeEl = milestone ? milestone.querySelector(".tiered-cart-discount__node") : null;
    // 节点注入礼品图（仅目标节点）
    renderNodeGift(nodeEl, tier);
    var nodeHasGiftImg = nodeEl && nodeEl.classList.contains("has-gift-image");

    // --- Row 1: wrap all non-gift children (amount text + strong spans) into .milestone-amount-row ---
    var existingRow = amountEl.querySelector(".tiered-cart-discount__milestone-amount-row");
    if (existingRow) {
      while (existingRow.firstChild) amountEl.insertBefore(existingRow.firstChild, existingRow);
      existingRow.remove();
    }

    if (hasGiftContent) {
      // 礼品块已表达奖励内容，删除冗余里程碑短标签
      while (amountEl.firstChild) amountEl.firstChild.remove();
    } else {
      var rowSpan = document.createElement("span");
      rowSpan.className = "tiered-cart-discount__milestone-amount-row";
      while (amountEl.firstChild) rowSpan.appendChild(amountEl.firstChild);
      amountEl.appendChild(rowSpan);
    }

    if (!gp) return;
    if (!gp.giftImageUrl && !shortName) return;

    if (milestone && milestone.classList.contains("tiered-cart-discount__milestone")) {
      milestone.classList.add("has-gift");
      milestone.classList.toggle("has-node-gift", Boolean(nodeHasGiftImg));
    }

    // gift-block: 节点已显示礼品图时只渲染文字名，否则图+名都渲染
    var side = amountEl.matches("[data-tcd-start-amount]") ? "start" : "end";
    var giftBlock = document.createElement("span");
    giftBlock.className = "tiered-cart-discount__milestone-gift-block";
    if (nodeHasGiftImg) giftBlock.classList.add("is-text-only");
    giftBlock.setAttribute("data-milestone-side", side);

    if (gp.giftImageUrl && !nodeHasGiftImg) {
      var thumb = document.createElement("span");
      thumb.className = "tiered-cart-discount__gift-thumb";
      var img = document.createElement("img");
      img.src = gp.giftImageUrl;
      img.alt = shortName || escapeHtml(gp.giftText || "");
      thumb.appendChild(img);
      giftBlock.appendChild(thumb);
    }
    if (shortName) {
      var nameEl = document.createElement("span");
      nameEl.className = "tiered-cart-discount__gift-name";
      nameEl.textContent = shortName;
      giftBlock.appendChild(nameEl);
    }
    amountEl.appendChild(giftBlock);
  }

  function setRootState(root, state, data) {
    var headerEl = root.querySelector("[data-tcd-header]");
    var headlineEl = root.querySelector("[data-tcd-headline]");
    var sublineEl = root.querySelector("[data-tcd-subline]");
    var barEl = root.querySelector("[data-tcd-bar]");
    var trackLabelEl = root.querySelector("[data-tcd-track-label]");
    var progressEl = root.querySelector("[data-tcd-progress]");
    var startAmountEl = root.querySelector("[data-tcd-start-amount]");
    var endAmountEl = root.querySelector("[data-tcd-end-amount]");
    var startNodeEl = root.querySelector("[data-tcd-start-node]");
    var endNodeEl = root.querySelector("[data-tcd-end-node]");
    var trackEl = root.querySelector("[data-tcd-track]");
    var successMarkEl = root.querySelector("[data-tcd-success-mark]");
    var previousMatchedIndex = Number(root.dataset.tcdMatchedIndex || -1);
    var previousAllUnlocked = root.dataset.tcdAllUnlocked === "true";
    var isInitialized = root.dataset.tcdInitialized === "true";

    if (headerEl) {
      headerEl.hidden = false;
      headerEl.classList.toggle("is-error", state === "error");
      headerEl.classList.toggle("is-unlocked", state === "unlocked");
    }

    if (headlineEl) {
      headlineEl.innerHTML = data.headline || data.message || "";
    }

    if (sublineEl) {
      var sublineText = data.subline || "";
      sublineEl.textContent = sublineText;
      sublineEl.hidden = !sublineText;
    }

    if (!data.segment) {
      if (barEl) barEl.hidden = true;
      root.classList.remove("is-all-unlocked");
      if (successMarkEl) {
        successMarkEl.hidden = true;
        successMarkEl.setAttribute("aria-hidden", "true");
      }
      return;
    }

    var segment = data.segment;
    var tiers = data.tiers || [];
    var enabledTierCount = tiers.length;
    var endUnlocked = segment.allUnlocked || state === "unlocked";
    // "Hide bar + show celebration only" (方案A) applies ONLY when the merchant
    // actually has 3+ tiers enabled AND the shopper unlocked the final one.
    // With 1-2 tiers enabled, reaching the top tier should still display the
    // full bar so the layout isn't left with an empty progress section.
    var hideBarForFullUnlock = endUnlocked && enabledTierCount >= 3;
    var matchedIndex = getMatchedTierIndex(
      tiers,
      data.totalPrice || 0,
    );
    var celebrateReason = null;

    if (isInitialized) {
      if (endUnlocked && !previousAllUnlocked) {
        celebrateReason = "all";
      } else if (!endUnlocked && matchedIndex > previousMatchedIndex) {
        celebrateReason = "tier";
      }
    }

    if (endUnlocked) {
      if (hideBarForFullUnlock) {
        root.classList.add("is-all-unlocked");
      } else {
        root.classList.remove("is-all-unlocked");
      }
      if (barEl) barEl.hidden = false;
      if (successMarkEl) {
        successMarkEl.hidden = false;
        successMarkEl.setAttribute("aria-hidden", "false");
      }
      // 先设置节点状态，再渲染里程碑礼品（renderNodeGift 需读取节点类名）
      if (endNodeEl) {
        setEndNodeState(endNodeEl, true);
      }
      if (segment.startTier && startNodeEl) {
        startNodeEl.classList.add("is-tier-passed");
      }
      if (endAmountEl) {
        var endBaseLabel =
          segment.endTier.milestoneLabel || segment.endTier.label || "";
        endAmountEl.textContent = endBaseLabel;
        renderMilestoneGift(endAmountEl, segment.endTier);
      }
      if (segment.startTier) {
        if (startAmountEl) {
          var showStart = segment.startTier.threshold > 0;
          var startBase = showStart
            ? segment.startTier.milestoneLabel ||
              segment.startTier.label ||
              ""
            : "";
          if (startBase) {
            startAmountEl.textContent = startBase;
          }
          renderMilestoneGift(startAmountEl, segment.startTier);
        }
      }
      root.dataset.tcdMatchedIndex = String(matchedIndex);
      root.dataset.tcdAllUnlocked = "true";
      root.dataset.tcdInitialized = "true";
      triggerCelebrate(root, celebrateReason);
      // Skip mid-tier style-setting block only when we actually want the
      // "header-only celebration" look (≥3 tiers and fully unlocked).
      // Otherwise fall through so the progress bar is still painted full.
      if (hideBarForFullUnlock) return;
    }

    root.classList.remove("is-all-unlocked");
    if (successMarkEl) {
      successMarkEl.hidden = true;
      successMarkEl.setAttribute("aria-hidden", "true");
    }

    if (!barEl) return;

    barEl.hidden = false;

    var startUnlocked = segment.startTier.threshold > 0;
    var showStartAmount = segment.startTier.threshold > 0;
    var fillPercent = Math.round(segment.progress * 100);

    if (trackLabelEl) {
      if (segment.endTier && segment.endTier.label && data.trackLabelTemplate) {
        trackLabelEl.textContent = replaceTokensPlain(data.trackLabelTemplate, {
          label: segment.endTier.label,
        });
      } else {
        trackLabelEl.textContent = "";
      }
    }

    if (progressEl && data.progressFormat) {
      progressEl.textContent = replaceTokensPlain(data.progressFormat, {
        progress: fillPercent,
      });
    }

    // 先设置节点状态类，再渲染里程碑礼品（renderNodeGift 需读取 is-target/is-unlocked 类名）
    setEndNodeState(endNodeEl, endUnlocked);

    if (startNodeEl) {
      startNodeEl.classList.toggle("is-tier-passed", startUnlocked);
      startNodeEl.classList.toggle("tiered-cart-discount__node--target", false);
      startNodeEl.classList.toggle(
        "tiered-cart-discount__node--initial",
        !startUnlocked,
      );
    }

    if (startAmountEl) {
      var startBaseLabel = data.initialLabel || "";
      if (showStartAmount) {
        startBaseLabel =
          segment.startTier.milestoneLabel ||
          segment.startTier.label ||
          formatMoney(
            segment.startTier.threshold,
            data.moneyFormat,
            data.currencyCode,
          );
      }
      startAmountEl.textContent = startBaseLabel;
      startAmountEl.hidden = false;
      startAmountEl.classList.toggle("is-active", startUnlocked);
      startAmountEl.classList.toggle(
        "is-initial-label",
        !showStartAmount && Boolean(data.initialLabel),
      );
      startAmountEl.classList.toggle(
        "is-hidden",
        !showStartAmount && !data.initialLabel,
      );
      renderMilestoneGift(startAmountEl, segment.startTier);
    }

    if (endAmountEl) {
      var endBaseLabel =
        segment.endTier.milestoneLabel || segment.endTier.label || "";
      endAmountEl.textContent = endBaseLabel;
      endAmountEl.classList.toggle("is-active", endUnlocked);
      endAmountEl.classList.toggle("is-goal", !endUnlocked);
      renderMilestoneGift(endAmountEl, segment.endTier);
    }

    if (trackEl) {
      triggerProgressAnimation(trackEl, fillPercent);
      trackEl.style.setProperty("--tcd-fill", fillPercent + "%");
      trackEl.style.removeProperty("background-image");
    }

    root.dataset.tcdMatchedIndex = String(matchedIndex);
    root.dataset.tcdAllUnlocked = "false";
    root.dataset.tcdInitialized = "true";
    triggerCelebrate(root, celebrateReason);
  }

  function renderRoot(root, cart, options) {
    var tiers = options.tiers;
    var totalPrice = getCartSubtotal(cart);
    var segment = getProgressSegment(tiers, totalPrice);
    var appliedTitles = getAppliedDiscountTitles(cart);
    var currencyCode = cart.currency || options.currencyCode;
    var progressPercent = Math.round(segment.progress * 100);
    var stateData = {
      moneyFormat: options.moneyFormat,
      currencyCode: currencyCode,
      initialLabel: options.initialLabel,
    };

    if (segment.allUnlocked) {
      var unlockedName = segment.matchedTier.discountName;
      var matchedApplied = appliedTitles.find(function (title) {
        return (
          title === normalizeDiscountName(segment.matchedTier.discountName)
        );
      });
      var unlockedTemplate = options.unlockedText;
      var isMatchedGift = segment.matchedTier.rewardType === "free_gift";
      var unlockedDiscountValue;
      var usedUnlockedSubtext;
      var unlockedLabelValue = segment.matchedTier.label;
      if (isMatchedGift) {
        // 礼品档的 message-label 直接显示礼品文案（如 "Free Gift"），
        // 礼品图片/名称由里程碑 gift-block 展示，标题不再内嵌 chip。
        var matchedGiftText = truncateGiftName(segment.matchedTier, 40);
        unlockedDiscountValue =
          matchedGiftText ||
          segment.matchedTier.label ||
          segment.matchedTier.discountName ||
          "";
        if (matchedGiftText) unlockedLabelValue = matchedGiftText;
        usedUnlockedSubtext =
          options.unlockedSubtextGift || options.unlockedSubtext;
      } else {
        unlockedDiscountValue = formatMoney(
          segment.matchedTier.discountAmount || 0,
          stateData.moneyFormat,
          stateData.currencyCode,
        );
        usedUnlockedSubtext = options.unlockedSubtext;
      }

      setRootState(root, "unlocked", {
        moneyFormat: stateData.moneyFormat,
        currencyCode: stateData.currencyCode,
        initialLabel: stateData.initialLabel,
        segment: segment,
        tiers: tiers,
        totalPrice: totalPrice,
        trackLabelTemplate: options.trackLabelTemplate,
        allRewardsUnlockedText: options.allRewardsUnlockedText,
        progressFormat: options.progressFormat,
        headline: replaceTokens(unlockedTemplate, {
          label: unlockedLabelValue,
          discount: unlockedDiscountValue,
          name: matchedApplied || unlockedName,
          progress: progressPercent,
        }),
        subline: replaceTokensPlain(usedUnlockedSubtext || "", {
          label: unlockedLabelValue,
          discount: unlockedDiscountValue,
          name: matchedApplied || unlockedName,
          progress: progressPercent,
        }),
      });
      return;
    }

    if (segment.nextTier) {
      var remainingAmount = formatMoney(
        segment.nextTier.threshold - totalPrice,
        stateData.moneyFormat,
        stateData.currencyCode,
      );
      var isNextGift = segment.nextTier.rewardType === "free_gift";
      var nextDiscountValue;
      var usedPromptText;
      var nextLabelValue = segment.nextTier.label;
      if (isNextGift) {
        // 礼品档的 message-label 直接显示礼品文案（如 "Free Gift"），
        // 礼品图片/名称由里程碑 gift-block 展示，标题不再内嵌 chip。
        var nextGiftText = truncateGiftName(segment.nextTier, 40);
        nextDiscountValue =
          nextGiftText ||
          segment.nextTier.label ||
          segment.nextTier.discountName ||
          "";
        if (nextGiftText) nextLabelValue = nextGiftText;
        usedPromptText = options.promptTextGift || options.promptText;
      } else {
        nextDiscountValue = formatMoney(
          segment.nextTier.discountAmount || 0,
          stateData.moneyFormat,
          stateData.currencyCode,
        );
        usedPromptText = options.promptText;
      }

      setRootState(root, "locked", {
        moneyFormat: stateData.moneyFormat,
        currencyCode: stateData.currencyCode,
        initialLabel: stateData.initialLabel,
        segment: segment,
        tiers: tiers,
        totalPrice: totalPrice,
        trackLabelTemplate: options.trackLabelTemplate,
        progressFormat: options.progressFormat,
        headline: replaceTokens(usedPromptText, {
          amount: remainingAmount,
          discount: nextDiscountValue,
          label: nextLabelValue,
          name: segment.nextTier.discountName,
          progress: progressPercent,
        }),
        subline: replaceTokensPlain(options.promptSubtext, {
          amount: remainingAmount,
          discount: nextDiscountValue,
          label: nextLabelValue,
          name: segment.nextTier.discountName,
          progress: progressPercent,
        }),
      });
      return;
    }

    setRootState(root, "locked", {
      moneyFormat: stateData.moneyFormat,
      currencyCode: stateData.currencyCode,
      initialLabel: stateData.initialLabel,
      segment: null,
      headline: "",
      subline: "",
    });
  }

  function update(root) {
    if (!root || root.dataset.tcdBusy === "true") return Promise.resolve();
    if (!isRootActive(root)) return Promise.resolve();

    var tiers = parseConfig(root);
    if (!tiers.length) {
      setLoading(root, false);
      return Promise.resolve();
    }

    var options = {
      tiers: tiers,
      moneyFormat: root.dataset.moneyFormat,
      currencyCode: root.dataset.currency,
      promptText: root.dataset.promptText,
      promptTextGift: root.dataset.promptTextGift,
      promptSubtext: root.dataset.promptSubtext,
      unlockedText: root.dataset.unlockedText,
      unlockedSubtext: root.dataset.unlockedSubtext,
      unlockedSubtextGift: root.dataset.unlockedSubtextGift,
      initialLabel: root.dataset.initialLabel,
      trackLabelTemplate: root.dataset.trackLabelTemplate,
      allRewardsUnlockedText: root.dataset.allRewardsUnlocked,
      errorText: root.dataset.errorText,
      progressFormat: root.dataset.progressFormat,
    };

    root.dataset.tcdBusy = "true";

    return fetchCart()
      .then(function (cart) {
        try {
          renderRoot(root, resolveCartForRoot(cart, tiers, root), options);
        } catch (error) {
          setRootState(root, "error", {
            moneyFormat: options.moneyFormat,
            currencyCode: options.currencyCode,
            segment: null,
            headline: options.errorText || "",
            subline: "",
          });
        }
      })
      .catch(function () {
        if (isDesignMode(root)) {
          try {
            renderRoot(
              root,
              resolveCartForRoot(
                { total_price: 0, item_count: 0 },
                tiers,
                root,
              ),
              options,
            );
          } catch (error) {
            setRootState(root, "error", {
              moneyFormat: options.moneyFormat,
              currencyCode: options.currencyCode,
              segment: null,
              headline: options.errorText || "",
              subline: "",
            });
          }
          return;
        }

        setRootState(root, "error", {
          moneyFormat: options.moneyFormat,
          currencyCode: options.currencyCode,
          segment: null,
          headline: options.errorText || "",
          subline: "",
        });
      })
      .finally(function () {
        root.dataset.tcdBusy = "false";
        setLoading(root, false);
        triggerEnterAnimation(root);
      });
  }

  function refreshAll() {
    var roots = getRunnableRoots();
    roots.forEach(function (root) {
      update(root);
    });
  }

  function init() {
    document
      .querySelectorAll("[data-tiered-cart-discount]")
      .forEach(bindInitialIconFallback);
    refreshAll();
  }

  function getRunnableRoots() {
    var roots = Array.prototype.slice.call(
      document.querySelectorAll("[data-tiered-cart-discount]"),
    );

    if (roots.some(isDesignMode)) return roots;

    var drawerRoots = roots.filter(function (root) {
      var drawer = root.closest && root.closest("cart-drawer.drawer.active");
      return Boolean(drawer);
    });
    if (drawerRoots.length) return drawerRoots;

    return roots.filter(function (root) {
      var drawer = root.closest && root.closest("cart-drawer.drawer");
      return !drawer;
    });
  }

  function isRootActive(root) {
    if (isDesignMode(root)) return true;

    var drawer = root.closest && root.closest("cart-drawer.drawer");
    if (drawer && !drawer.classList.contains("active")) return false;
    return root.offsetParent !== null || Boolean(root.getClientRects().length);
  }

  function resetRootForReload(root) {
    if (!root) return;

    root.dataset.tcdInitialized = "";
    root.dataset.tcdEntered = "";
    root.dataset.tcdMatchedIndex = "-1";
    root.dataset.tcdAllUnlocked = "false";
    root.dataset.tcdBusy = "false";
    root.classList.remove("is-all-unlocked", "is-celebrate", "is-entering");
    setLoading(root, true);
  }

  function handleSectionLoad(event) {
    var scope = event && event.target ? event.target : document;
    var roots = scope.querySelectorAll
      ? scope.querySelectorAll("[data-tiered-cart-discount]")
      : [];

    Array.prototype.forEach.call(roots, function (root) {
      resetRootForReload(root);
      bindInitialIconFallback(root);
      update(root);
    });
  }

  window.TieredCartDiscount = {
    init: init,
    refresh: refreshAll,
  };

  document.addEventListener("DOMContentLoaded", init);
  document.addEventListener("cart:updated", refreshAll);
  document.addEventListener("cart:refresh", refreshAll);
  document.addEventListener("shopify:section:load", handleSectionLoad);

  if (
    typeof subscribe === "function" &&
    typeof PUB_SUB_EVENTS !== "undefined" &&
    PUB_SUB_EVENTS.cartUpdate
  ) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, refreshAll);
  }

  var observer = new MutationObserver(function (mutations) {
    var shouldRefresh = mutations.some(function (mutation) {
      if (mutation.type === "attributes") {
        return (
          mutation.target &&
          mutation.target.matches &&
          mutation.target.matches("cart-drawer.drawer.active")
        );
      }
      return Array.prototype.slice
        .call(mutation.addedNodes || [])
        .some(function (node) {
          if (node.nodeType !== 1) return false;
          if (node.matches && node.matches("[data-tiered-cart-discount]"))
            return true;
          return (
            node.querySelector &&
            node.querySelector("[data-tiered-cart-discount]")
          );
        });
    });
    if (shouldRefresh) {
      document
        .querySelectorAll("[data-tiered-cart-discount]")
        .forEach(bindInitialIconFallback);
      refreshAll();
    }
  });

  if (document.documentElement) {
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["class"],
      childList: true,
      subtree: true,
    });
  }
})();
